import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InquiryStatusType } from './../../../../_shared/enums/inbox/inquiryStatusType.enum';

@Component({
    selector: 'cmp-form-dropdown',
    templateUrl: './cmp-dropdown.component.html',
    styles: [],
})
export class CmpDropdownComponent implements OnInit {
    @Input()
    set setSelected(selected: InquiryStatusType) {
        this.selected = selected;
        this.selectedStatus = this.list.find(el => el.id == selected);
        if (!this.selectedStatus) {
            this.selectedStatus = this.list.find(el => el.id == InquiryStatusType.NEW);
        }
    }

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onChange = new EventEmitter();

    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    list: any;

    public selected: InquiryStatusType;

    // public data: any[] = inquiryStatusElements.LIST;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public selectedStatus: any;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
    ngOnInit() {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public selectionChange(data: any): void {
        this.selected = data.id;
        this.selectedStatus = this.list.find(el => el.id == this.selected);
        this.onChange.next(data.id);
    }
}
